import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

/// update code
export const fetchReconciliations = async ({
  limit,
  page,
  filters,
  sort,
  ret,
  ref,
  incl,
}) => {
  try {
    const [clientsResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.RECONCILIATION.GET_ALL,
        params: {
          coll: "Reconciliation",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.RECONCILIATION.GET_TOTAL_COUNT,
        params: {
          coll: "Reconciliation",
          fil: JSON.stringify(filters),
        },
      }),
    ]);
    return {
      data: clientsResponse?.data?.data || [],
      totalCount: totalCountResponse?.data?.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Fetch one client by UIID
export const fetchOneReconciliation = async ({
  reconciliationUiid,
  retrieve,
  ref,
  incl,
}) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.RECONCILIATION.GET_BY_UIID,
    params: {
      coll: "Reconciliation",
      ret: retrieve,
      ref: ref,
      fil: JSON.stringify({
        uiid: { type: "NONE", value: reconciliationUiid },
      }),
      incl,
    },
  });
};
export const addNewReconciliation = async (clientData) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.RECONCILIATION.ADD_NEW,
    data: {
      coll: "Reconciliation",
      payload: clientData,
    },
  });
};
export const updateReconciliation = async ({
  coll,
  uploadType,
  field,
  payload
}) => {
  const params = {
    coll,
    uploadType,
    field
  };

  const formData = new FormData();
  // formData.append("month", JSON.stringify(payload.month));
  // formData.append("year", JSON.stringify(payload.year));
  // formData.append("provider", JSON.stringify(payload.provider));
  formData.append("month", payload.month);
  formData.append("year", payload.year);
  formData.append("provider", payload.provider);
  formData.append("doc", payload.doc[0]);
  formData.append("addedBy", payload.addedBy);

      console.log("api is running..........");


  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.RECONCILIATION.UPDATE,
    data: formData,
    params,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
